import { webVersionUi } from './webVersion';

// The foldable / iPhone Duo wide-screen rules in theme.css are for the APP on a foldable only. Two kinds of screen keep
// their layout exactly as it was, each marked once on <html> at load (main.tsx, first boot step):
//   data-ipad — an iPad (Owner 2026-10-25: 「ipad暂时保持原样。我要先看看效果」), from the user agent, no native plugin.
//     An iPad's WKWebView (and Safari) asks for desktop sites by default, so it reports "Macintosh"; a Mac has no
//     touch points, an iPad has five.
//   data-web — the web version in any browser (Owner 2026-10-25: 「验屋师网页版在电脑浏览器上也保持原样，新布局只给折叠屏。」),
//     decided by webVersionUi(): a built site in a browser always is; the native app never is; the development server
//     stands in for the app unless `localStorage['yanwushi-dev:web'] = '1'` (src/app/webVersion.ts) — a switch that
//     exists only in development builds, so the production web version can never take the app's layout.
export function isIPad(nav: Pick<Navigator, 'userAgent' | 'maxTouchPoints'>): boolean {
  return /\biPad\b/.test(nav.userAgent) || (/\bMacintosh\b/.test(nav.userAgent) && nav.maxTouchPoints > 1);
}

export function markIPad(doc: Document = document, nav: Pick<Navigator, 'userAgent' | 'maxTouchPoints'> = navigator): boolean {
  const ipad = isIPad(nav);
  if (ipad) doc.documentElement.dataset.ipad = 'true';
  return ipad;
}

export function markedIPad(doc: Document = document): boolean {
  return doc.documentElement.dataset.ipad === 'true';
}

export function markWebVersion(doc: Document = document, web: boolean = webVersionUi()): boolean {
  if (web) doc.documentElement.dataset.web = 'true';
  return web;
}

export function markedWebVersion(doc: Document = document): boolean {
  return doc.documentElement.dataset.web === 'true';
}

// Where the foldable layout and its fold / unfold scroll keeping apply: the app, not on an iPad.
export function foldLayoutAllowed(doc: Document = document): boolean {
  return !markedIPad(doc) && !markedWebVersion(doc);
}
